import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer footer-center p-10 bg-base-300 text-base-content">
      <div className="grid grid-flow-row gap-4">
        <div>
          <div className="flex gap-4 md:gap-6">
            <Link to="/impressum" className="link link-hover">
              Impressum
            </Link>
            <span className="text-base-content/30">|</span>
            <Link to="/datenschutz" className="link link-hover">
              Datenschutz
            </Link>
            <span className="text-base-content/30">|</span>
            <Link to="/agb" className="link link-hover">
              AGB
            </Link>
          </div>
        </div>
        <div>
          <p className="font-light">
            &copy; {new Date().getFullYear()} Mein-SKS
            <br/>
            <span className="text-sm opacity-70">Dein Begleiter auf dem Weg zum Segelschein</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 